"use client";
import React from "react";
import { useAnalytics } from "providers/AnalyticsProvider";

type ButtonProps = {
  url?: string;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
};

const Link = ({
  url,
  children,
  disabled = false,
  className = "",
  onClick,
}: ButtonProps) => {
  const { trackEvent, trackConversion } = useAnalytics();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }

    // Track the event when the link is clicked
    trackEvent("link_click", {
      url,
      label: children?.toString(),
    });

    // Optionally track a conversion
    trackConversion("link_conversion", 1);
  };

  return (
    <a
      className={`${className}`}
      href={url}
      onClick={handleClick}
      aria-disabled={disabled}
      title={children?.toString() || undefined}
    >
      {children}
    </a>
  );
};

export default Link;
